import { IStep } from "@models/ui-models/step";

export enum UnitTrustEstablishmentFormStepsEnum {
  FormDescription,
  TrustDetailsAndAddress,
  Trustees,
  Unitholders,
  AuthorisedSignatories,
}

export const UnitTrustEstablishmentFormSteps: IStep<UnitTrustEstablishmentFormStepsEnum>[] = [
  {
    label: 'Description',
    step: UnitTrustEstablishmentFormStepsEnum.FormDescription
  },
  {
    label: 'Trust Details and Address',
    step: UnitTrustEstablishmentFormStepsEnum.TrustDetailsAndAddress
  },
  {
    label: 'Trustees',
    step: UnitTrustEstablishmentFormStepsEnum.Trustees
  },
  {
    label: 'Unitholders',
    step: UnitTrustEstablishmentFormStepsEnum.Unitholders
  },
  {
    label: 'Authorised Signatory',
    step: UnitTrustEstablishmentFormStepsEnum.AuthorisedSignatories
  },
];
